// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'

import { StyleSheet, Text } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  sectionItemProperty: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    flexWrap: 'nowrap',
    color: '#767676',
    fontFamily: 'Helvetica',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: '400',
    textAlign: 'left',
  },

  sectionItemPropertyValue: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    flexWrap: 'nowrap',
    fontFamily: 'Helvetica',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: '400',
    textAlign: 'left',
    color: '#141414',
    marginBottom: 8,
  },
})
// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
const PatientChartsPrintedFriendlySectionItemProperty = ({ name, value }) => (
  <Text key={name} style={styles.sectionItemPropertyValue}>
    {name}: <Text style={styles.sectionItemProperty}>{value}</Text>
  </Text>
)

export default PatientChartsPrintedFriendlySectionItemProperty
